import css from "styled-jsx/css";
import { VIEWPORT_SIZE } from "utils/constants/viewport";

export const getPreviewStyles = ({ fontFamily, editorViewport }) => {
  const bgColor =
    editorViewport === VIEWPORT_SIZE.MOBILE ? "white" : "transparent";

  return css.resolve`
    :global(.preview-styles) {
      min-height: calc(100vh - 280px);
      font-family: ${fontFamily}, sans-serif !important;
      background-color: ${bgColor};
    }
  `;
};
